<template>
  <v-navigation-drawer id="appDrawer" v-model="drawer" :mini-variant.sync="mini" :mobile-break-point="10240" :dark="$vuetify.dark" fixed app width="260">
    <v-toolbar color="primary darken-1" dark>
      <img :src="computeLogo" height="36" alt />
      <v-toolbar-title class="ml-0 pl-3">
        <span class="hidden-sm-and-down">Admin Console</span>
      </v-toolbar-title>
    </v-toolbar>
    <vue-perfect-scrollbar :settings="scrollSettings" class="drawer-menu--scroll">
      <v-list dense expand>
        <template v-for="(item, i) in menus">
          <!--group with subitems-->
          <v-list-group v-if="item.items" :key="item.name" :group="item.group" :prepend-icon="item.icon" no-action="no-action">
            <v-list-tile slot="activator" ripple="ripple">
              <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <template v-for="(subItem, i) in item.items">
              <!--sub group-->
              <v-list-group v-if="subItem.items" :key="subItem.name" :group="subItem.group" sub-group="sub-group">
                <v-list-tile slot="activator" ripple="ripple">
                  <v-list-tile-content>
                    <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile v-for="(grand, j) in subItem.children" :key="j" :to="genChildTarget(item, grand)" :href="grand.href" ripple="ripple">
                  <v-list-tile-content>
                    <v-list-tile-title>{{ grand.title }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list-group>
              <!--child item-->
              <v-list-tile
                v-else
                :key="i"
                :to="genChildTarget(item, subItem)"
                :href="subItem.href"
                :disabled="subItem.disabled"
                :target="subItem.target"
                active-class="primary lighten-5"
                ripple="ripple"
              >
                <v-list-tile-content>
                  <v-list-tile-title>
                    <span>{{ subItem.title }}</span>
                  </v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action v-if="subItem.action">
                  <v-icon :class="[subItem.actionClass || 'success--text']">{{ subItem.action }}</v-icon>
                </v-list-tile-action>
              </v-list-tile>
            </template>
          </v-list-group>
          <v-subheader v-else-if="item.header" :key="i">{{ item.header }}</v-subheader>
          <v-divider v-else-if="item.divider" :key="i"></v-divider>
          <!--top-level link-->
          <v-list-tile
            v-else
            :key="item.name"
            :to="!item.href ? { name: item.name } : null"
            :href="item.href"
            :disabled="item.disabled"
            :target="item.target"
            ripple="ripple"
            rel="noopener"
            active-class="primary lighten-5"
            exact
          >
            <v-list-tile-action v-if="item.icon">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action v-if="item.subAction">
              <v-icon class="success--text">{{ item.subAction }}</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-list>
    </vue-perfect-scrollbar>
  </v-navigation-drawer>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar';
  import { mapGetters, mapActions } from 'vuex';
  export default {
    name: 'AppDrawer',
    components: {
      VuePerfectScrollbar,
    },
    props: {
      expanded: {
        type: Boolean,
        default: false,
      },
    },
    data: () => ({
      mini: false,
      drawer: false,
      scrollSettings: {
        maxScrollbarLength: 160,
      },
    }),
    computed: {
      ...mapGetters(['menus']),
      computeGroupActive() {
        return true;
      },
      computeLogo() {
        return '/logo.svg';
      },
      sideToolbarColor() {
        return this.$vuetify.options.extra.sideNav;
      },
    },
    watch: {
      /*
      drawer() {
        console.log('drawer', this.drawer);
      },
    */
    },
    created() {
      this.loadMenu();
      window.getApp.$on('APP_DRAWER_TOGGLED', () => {
        this.drawer = !this.drawer;
      });
    },
    methods: {
      ...mapActions(['loadMenu']),
      genChildTarget(item, subItem) {
        if (subItem.href) return;
        if (subItem.component) {
          return {
            name: subItem.component,
          };
        }
        return { name: `${item.group}/${subItem.name}` };
      },
    },
  };
</script>

<style lang="stylus">
  #appDrawer {
    overflow: hidden;

    .drawer-menu--scroll {
      height: calc(100vh - 48px);
      overflow: auto;
    }
  }
</style>
